export { CopyPasteEntrypoint } from './copyPasteEntry';
